/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { useEventTracker } from '@applyboard/ui-utils';
import useInitialProps from "../../../hooks/useInitialProps";
import { _NoteTabBarWrapper, _NoteTabTopBar } from "../../Notes/styles";
import { _AddItemsButton } from "../../RequirementsOld/styles";
var CustomFieldsTabBar = function CustomFieldsTabBar(_ref) {
  var onInsertField = _ref.onInsertField;
  var _useInitialProps = useInitialProps(),
    application = _useInitialProps.application;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  return /*#__PURE__*/React.createElement(_NoteTabBarWrapper, null, /*#__PURE__*/React.createElement(_NoteTabTopBar, null, /*#__PURE__*/React.createElement(_AddItemsButton, {
    onClick: function onClick() {
      trackEvent({
        event: 'Single Application - Application Details - Created Custom Field',
        data: {
          applicationCurrentStage: application.current_stage
        }
      });
      onInsertField();
    }
  }, "Add Custom Field ", /*#__PURE__*/React.createElement(FontAwesome, {
    name: "plus"
  }))));
};
export default CustomFieldsTabBar;